import React, {ElementType, FC, ReactElement, useMemo} from 'react';

export interface IconProps {
    name: string
    className?: string
}

export const loadSvg = (name: string): ElementType | null => {
    try {
        return require(`!!@svgr/webpack?-svgo,+titleProp,+ref!./icons/${name}.svg`).default;
    } catch (e) {
        return null;
    }
};

const Icon: FC<IconProps> = ({name, className}): ReactElement | null => {
    const Component = useMemo<ElementType | null>(() => loadSvg(name), [name]);
    return !!Component ? <Component className={className}/> : null;
};

export default Icon;
